import { render, staticRenderFns } from "./VerificacionSancionesAdministrativas.vue?vue&type=template&id=0e7f06bd"
import script from "./VerificacionSancionesAdministrativas.vue?vue&type=script&lang=js"
export * from "./VerificacionSancionesAdministrativas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports